let FAV_BOOK_API_URL = "";
if (window.location.hostname === "a-dev.tbbt.com.tw"){
  FAV_BOOK_API_URL = `https://a-dev.tbbt.com.tw/reference-bg/favoriteBook`
} else if (window.location.hostname === "qa-textbook.hle.com.tw" || window.location.hostname === "qa-reference.hle.com.tw"){
  FAV_BOOK_API_URL = `https://qa-rbook.hle.com.tw/reference-bg/favoriteBook`
}else if (window.location.hostname === "textbook.hle.com.tw" || window.location.hostname === "reference.hle.com.tw"){
  FAV_BOOK_API_URL = `https://rbook.hle.com.tw/reference-bg/favoriteBook`
} else {
  FAV_BOOK_API_URL = `https://qa-rbook.hle.com.tw/reference-bg/favoriteBook`
}

class FavoriteBookService{
  retrieveFavoriteBookByEmailEdu(favBookEmailEdu){
    return axios.post(`${FAV_BOOK_API_URL}/materialId`, favBookEmailEdu)
  }
  retrieveFavoriteBookByEmailYearEduSubject(favBookEmailYearEduSubject){
    return axios.post(`${FAV_BOOK_API_URL}/materials`,favBookEmailYearEduSubject )
  }

  deleteFavoriteBookByMaterialId(materialId){
    return axios.delete(`${FAV_BOOK_API_URL}/${materialId}`)
  }

  addFavoriteBook(favoriteBook){
    return axios.post(`${FAV_BOOK_API_URL}`, favoriteBook)
  }
}
